import { render, staticRenderFns } from "./digital-currency-alternative-resource-item-2-find-customers-searching-for-digital-currency-alternatives.vue?vue&type=template&id=e9c0daa4&scoped=true&"
import script from "./digital-currency-alternative-resource-item-2-find-customers-searching-for-digital-currency-alternatives.vue?vue&type=script&lang=ts&"
export * from "./digital-currency-alternative-resource-item-2-find-customers-searching-for-digital-currency-alternatives.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c0daa4",
  null
  
)

export default component.exports